import FormFieldViewText from "components/FormFields/ViewText";
import FormField from "ds/components/Form/Field";
import SecretFieldDetails from "ds/components/SecretFieldDetails";
import { BitbucketDatacenterIntegration } from "types/generated";

import { REGENERATE_BITBUCKET_DATACENTER_INTEGRATION_WEBHOOK_SECRET } from "../../gql";
import { useRefreshSecret } from "../../useRefreshSecret";
import VCSIntegrationsUseGitCheckoutInfo from "./UseGitCheckoutInfo";
import { VCSCheckLabels } from "./helpers";

type VCSIntegrationsDetailsBitbucketDataCenterProps = {
  details: BitbucketDatacenterIntegration;
  canEdit?: boolean;
};

const VCSIntegrationsDetailsBitbucketDataCenter = ({
  details,
  canEdit,
}: VCSIntegrationsDetailsBitbucketDataCenterProps) => {
  const [webhookSecret, regenerateSecret] = useRefreshSecret(
    details.id,
    details.webhookSecret,
    REGENERATE_BITBUCKET_DATACENTER_INTEGRATION_WEBHOOK_SECRET,
    (data) => data.bitbucketDatacenterIntegrationRegenerateWebhookSecret.webhookSecret
  );

  return (
    <>
      <FormFieldViewText label="API host URL" value={details.apiHost} />

      <FormFieldViewText label="User facing host URL" value={details.userFacingHost} />

      <FormFieldViewText label="Username" value={details.username} />

      <FormField label="Webhook secret">
        <SecretFieldDetails
          secret={webhookSecret}
          regenerateSecret={canEdit ? regenerateSecret : undefined}
        />
      </FormField>

      <FormFieldViewText
        label="Webhook endpoint"
        value={details.webhookURL}
        withCopy
        noTextEllipsis
        textWordBreak
      />

      <VCSIntegrationsUseGitCheckoutInfo value={details.useGitCheckout} />

      <FormFieldViewText label="VCS checks" value={VCSCheckLabels[details.vcsChecks]} />
    </>
  );
};

export default VCSIntegrationsDetailsBitbucketDataCenter;
